/**
 * «Твоя добірка» — фінальний екран онбордингу і він же екран гейта.
 *
 * Кнопка веде далі: у стрічку, якщо доступ відкритий, або на екран `/unlock`,
 * якщо людина ще не підписана на канал. Сам екран від цього не змінюється —
 * рішення, куди вести, приймає сторінка онбордингу.
 */
import { AuraBackground } from "@/components/AuraBackground";
import { ScribbleStar, ScribbleUnderline } from "@/components/Icon";

export function SelectionReady({
  total,
  topInset = 0,
  onPrimary,
  caption,
}: {
  /** Скільки вакансій у сферах людини за вікно, яке рахує бекенд (тиждень). */
  total: number;
  topInset?: number;
  onPrimary: () => void;
  /** Рядок під кнопкою. Онбординг підставляє свій (промокод). */
  caption?: React.ReactNode;
}) {
  return (
    <>
      <AuraBackground />
      <div
        className="relative min-h-screen overflow-hidden px-5 pb-12"
        style={{ paddingTop: topInset + 48 }}
      >
        <ScribbleStar
          size={24}
          className="pointer-events-none absolute right-7 top-[7.375rem] opacity-80"
        />

        <div className="relative flex items-center gap-2 font-mono text-[0.625rem] uppercase tracking-[0.12em] text-ink-dim">
          <span className="h-1.5 w-1.5 rounded-full bg-primary" />
          добірка готова
        </div>
        <h1
          className="relative mt-3 font-display font-bold text-ink"
          style={{ fontSize: "2.5rem", lineHeight: 1, letterSpacing: "-0.03em" }}
        >
          Твоя{" "}
          <span className="relative inline-block">
            <span className="accent-italic" style={{ fontWeight: 600 }}>
              добірка.
            </span>
            <ScribbleUnderline width={150} className="absolute -bottom-2 -left-1" />
          </span>
        </h1>

        <div className="relative mt-7 rounded-ios-hero bg-surface shadow-card p-6 text-center">
          <div className="font-mono text-[0.625rem] uppercase tracking-[0.16em] text-ink-dim mb-1">
            за останній тиждень
          </div>
          <div
            className="font-display font-bold text-ink"
            style={{ fontSize: "4.75rem", lineHeight: 1, letterSpacing: "-0.04em" }}
          >
            {total}
          </div>
          <div className="mt-1 font-serif italic text-[0.9375rem] text-ink-dim">
            вакансій у твоїх сферах
          </div>
        </div>

        <div className="relative mt-5">
          <button
            type="button"
            onClick={onPrimary}
            className="block w-full rounded-full bg-primary py-3.5 font-display text-[0.9375rem] font-semibold text-white shadow-card active:bg-primary-deep"
          >
            Подивитись вакансії
          </button>
          <p className="mt-2.5 text-center text-[0.78125rem] leading-snug text-ink-dim [text-wrap:balance]">
            {caption ?? "Усі вакансії за тиждень — у твоїй стрічці"}
          </p>
        </div>
      </div>
    </>
  );
}
